export default __webpack_public_path__ + "static/media/receipt-success.cc4bdac6.svg";